export default __webpack_public_path__ + "static/media/minimize-ticket.b60b6060.svg";